import React from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import Options from './Options';
import ElementHolder from './ElementHolder';
import StatusBar from './StatusBar';
import MainArea from './MainArea';
import ToolBar from './ToolBar';
import Exit from './icons/Exit';

import styles from '../../../../stylesheet/css/header-builder/app.css';

const App = React.createClass({
  render() {
    return (
      <div style={{position: 'relative'}}>
        <div className={styles.header}>
          <div className={styles.wrapper}>
            <ToolBar />
          </div>
        </div>
        <div className={styles.mainArea}>
          <div className={styles.wrapper}>
            <MainArea />
          </div>
        </div>

        <div className={styles.shortcutsArea}>
          <div className={styles.wrapper}>
            <ElementHolder />
            <Exit />
          </div>
        </div>

        <div className={styles.optionsArea}>
          <div className={styles.wrapper}>
            <Options />
          </div>
        </div>

        <div className={styles.footer}>
          <div className={styles.wrapper}>
            <StatusBar />
          </div>
        </div>
      </div>
    );
  }
});

export default DragDropContext(HTML5Backend)(App);


// WEBPACK FOOTER //
// ./app/header-builder/components/App.js